import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import App from "./App";

import "./helpers/number-extensions";
import "./helpers/string-extensions";
import "./helpers/date-extensions";
import "./helpers/array-extensions";
import { StrictMode } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

/**
 * Polyfill for react-image-cropper, react-transition-group and other libraries
 * that use findDOMNode (removed from React 19)
 */
if (typeof (ReactDOM as any).findDOMNode === "undefined") {
  (ReactDOM as any).findDOMNode = (instance: any) => {
    // Null or undefined returns null
    if (!instance) {
      return null;
    }

    // If it's already a DOM node, return it directly
    if (instance instanceof Element || instance instanceof Document) {
      return instance;
    }

    // For class components with refs
    if (instance.nodeType) {
      return instance;
    }

    // For React component instances
    // Try accessing via _reactInternals (React 18+)
    if (instance._reactInternals) {
      let fiber = instance._reactInternals;
      while (fiber) {
        // Search for the DOM node in the fiber
        if (fiber.stateNode instanceof Element) {
          return fiber.stateNode;
        }
        // Go to the parent fiber if necessary
        fiber = fiber.return;
      }
    }

    // For React 16/17 via _reactInternalFiber
    if ((instance as any)._reactInternalFiber) {
      let fiber = (instance as any)._reactInternalFiber;
      while (fiber) {
        if (fiber.stateNode instanceof Element) {
          return fiber.stateNode;
        }
        fiber = fiber.return;
      }
    }

    // Fallback: try to find via parentNode
    if (instance.parentNode instanceof Element) {
      return instance.parentNode;
    }

    return null;
  };
}

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}
